/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React components
import { IconButton, Chip, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete"
import Popconfirm from "components/Popconfirm/Popconfirm";
import ReportCell from "layouts/pages/dealersMisatkes/reportCell";
import { format } from 'date-fns';

const STATUS_CHIP = {
  APPROVED:       { label: "Approved",       color: "success" },
  PENDING_REVIEW: { label: "Pending Review", color: "warning" },
  REJECTED:       { label: "Rejected",       color: "default" },
};

function StatusChip({ status, rejectReason }) {
  const cfg = STATUS_CHIP[status] ?? { label: status ?? "-", color: "default" };
  const chip = <Chip label={cfg.label} color={cfg.color} size="small" />;
  if (status === "REJECTED" && rejectReason) {
    return (
      <Tooltip title={`Reason: ${rejectReason}`} placement="top" arrow>
        <span>{chip}</span>
      </Tooltip>
    );
  }
  return chip;
}

export default function data({mistakes = [], user = {}, onImageClick, deleteAction}) {

  const rows = mistakes.map((mistake) => {
    const rowsData =  {
      dealer: mistake?.dealer?.name,
      date: format(new Date(new Date(mistake.date).toISOString().split('T')[0]), 'dd.MM.yyyy'),
      time: mistake.time,
      type: mistake?.type,
      studio: mistake?.studio?.name ?? "-",
      table: mistake?.table?.name ?? "-",
      gameId: mistake?.gameId ?? "-",
      manager:  mistake?.user?.name ?? "-",
      mistake: mistake?.mistakeRelation?.name,
      resolution: mistake?.resolution,
      image: mistake.imageURL ? (
        <img 
          src={mistake.imageURL} 
          width={300} 
          height={300}
          style={{
            width: "80px",
            height: "80px",
            objectFit: "cover",
            borderRadius: "8px",
            cursor: "pointer",
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            transition: "transform 0.3s ease-in-out",
          }}
          onClick={() => onImageClick(mistake.imageURL)}
        />
      ) : (
        "Not provided"
      ),
      note: mistake.note ?? "-",
      status: <StatusChip status={mistake.status} rejectReason={mistake.reject_reason} />,
      report: mistake.report ? <ReportCell reportText={mistake.report} />:  "-",
        // action: (
        //   <MDTypography component="a" style={{cursor: "pointer"}} variant="caption" color="text" fontWeight="medium" onClick={() => editAction(mistake)}>
        //     Edit
        //   </MDTypography>
        // ),
    };

    if (['admin'].includes(user.role)) {
      rowsData['action'] = (<div>
        <Popconfirm
          title="Are you sure ?"
          onConfirm={() => deleteAction(mistake)}
        >
          <IconButton
            aria-label="delete"
            sx={{ color: "error.main" }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Popconfirm>
      </div>
      )
    }

    return rowsData;
  });

  const columns = [
    { Header: "Dealer", accessor: "dealer", align: "left" },
    { Header: "Type", accessor: "type", align: "left" },
    { Header: "Mistake", accessor: "mistake", align: "left" },
    { Header: "Resolution", accessor: "resolution", align: "left" },
    { Header: "Date", accessor: "date", align: "left" },
    { Header: "Time", accessor: "time", align: "left" },
    { Header: "Studio", accessor: "studio", align: "left" },
    { Header: "Table", accessor: "table", align: "left" },
    { Header: "Game Id", accessor: "gameId", align: "left" },
    { Header: "Manager", accessor: "manager", align: "left" },
    { Header: "Status", accessor: "status", align: "left" },
    { Header: "Note", accessor: "note", align: "left" },
    { Header: "Image", accessor: "image", align: "left" },
    { Header: "Report", accessor: "report", align: "left" },
  ];

  if (['admin'].includes(user.role)) {
    columns.push({ Header: "Action", accessor: "action", align: "left" })
  }

  return {
    columns,

    rows: rows,
  };
}
